import { SetStateAction, useCallback, useContext } from "react";

import { IndexerValueTypes } from "../../interfaces/IndexerValueTypes";

import { CreditProposalResult } from "./../../interfaces/CreditProposalResult";

import { CreditProposalResultContext } from "./creditProposalResult-context";

export const useCreditProposalResult = () => {
  const { creditProposalResult, setCreditProposalResult } = useContext(
    CreditProposalResultContext
  );

  const createCreditProposalResult = useCallback(
    (newCustomer: CreditProposalResult): void => {
      setCreditProposalResult(newCustomer);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [creditProposalResult]
  );

  const onChangeCreditProposalResult = useCallback(
    (key: string, newValue: IndexerValueTypes): void => {
      setCreditProposalResult({
        ...creditProposalResult,
        [key]: newValue,
      } as SetStateAction<CreditProposalResult | undefined>);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [creditProposalResult]
  );

  const deleteCreditProposalResult = useCallback((): void => {
    setCreditProposalResult(undefined);
    sessionStorage.removeItem("CEX-creditProposal");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditProposalResult]);

  return {
    creditProposalResult,

    createCreditProposalResult,

    onChangeCreditProposalResult,

    deleteCreditProposalResult,
  };
};
